import theme from "../../../../theme";
import { Box, IconButton, ListItem, ListItemButton, ListItemIcon, ListItemText, SxProps, Theme } from "@mui/material";
import { ArrowForward, BarChart } from "@mui/icons-material";
import {
  BillingReport,
  CaseReport,
  DocumentIntakeReport,
  InventoryPredictionsReport,
  ThroughputReport,
  UploadActivityReport,
} from "../../../../components/Icons";

const customIconSx: SxProps<Theme> = {
  position: "relative",
  top: 3,
  left: 3,
};

const reportMeta = {
  "Document Intake Report": {
    color: theme.palette.primary.light,
    icon: <DocumentIntakeReport sx={customIconSx} />,
  },
  "Inventory Predictions": {
    color: theme.palette.patternSecondary.light,
    icon: <InventoryPredictionsReport sx={customIconSx} />,
  },
  "Case Report": {
    color: theme.palette.tertiary.light,
    icon: <CaseReport sx={customIconSx} />,
  },
  "Billing Report": {
    color: theme.palette.primary.light,
    icon: <BillingReport sx={customIconSx} />,
  },
  "Throughput Report": {
    color: theme.palette.patternSecondary.light,
    icon: <ThroughputReport sx={customIconSx} />,
  },
  "Upload Activity": {
    color: theme.palette.tertiary.light,
    icon: <UploadActivityReport sx={customIconSx} />,
  },
};

export interface ReportListItemProps {
  name: string;
  id: string;
  onClick: (reportId: string) => void;
}

const ReportListItem = (props: ReportListItemProps) => {
  const { name, id, onClick } = props;
  const matchingMeta = reportMeta[name];
  return (
    <ListItem id={id} sx={{ padding: 0 }}>
      <ListItemButton
        onClick={() => onClick(id)}
        sx={{
          paddingY: 2,
          display: "flex",
          justifyContent: "space-between",
        }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}>
          <ListItemIcon
            sx={{
              height: 34,
              width: 34,
              minWidth: 34,
              marginRight: 2,
              borderRadius: 1,
              backgroundColor: matchingMeta ? matchingMeta.color : theme.palette.grey[100],
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}>
            {matchingMeta ? matchingMeta.icon : <BarChart />}
          </ListItemIcon>
          <ListItemText primary={name} />
        </Box>
        <IconButton edge="end" onClick={() => onClick(id)}>
          <ArrowForward />
        </IconButton>
      </ListItemButton>
    </ListItem>
  );
};

export default ReportListItem;
